import BaseApi from 'common/apiRequest/apis/BaseApi';
import { Request } from '../apiConcentrator/Admin';
import APINames from '../APINames';

class AdminUserApi extends BaseApi {
  public requestInstance = new Request(APINames.USER);

  // 退出企业
  writeOffTenant(accountId: string) {
    return this.requestInstance.post(['account', accountId, ':signOff']);
  }
}
export default new AdminUserApi();
